import type { SxProps, Theme } from '@mui/material/styles';

export const applyColors = {
  background: '#111217',
  panel: '#1A1B23',
  panelAlt: '#1E1F25',
  border: '#FFFFFF1A',
  borderStrong: '#99A8FF33',
  primary: '#354EEF',
  primaryHover: '#2a3fd4',
  accent: '#CCD4FF',
  accentSoft: '#99A8FF',
  premium: '#FFD86D',
  success: '#27D348',
  danger: '#FF6B6B',
  textMuted: '#9CA3AF',
  textBody: '#D1D5DB',
} as const;

export const sectionTitleSx: SxProps<Theme> = {
  fontSize: { xs: 16, md: 18 },
  fontWeight: 600,
  color: '#FFFFFF',
  mb: 0.5,
};

export const sectionHintSx: SxProps<Theme> = {
  fontSize: 13,
  color: applyColors.textMuted,
  mb: 1.5,
};

export const fieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: applyColors.panelAlt,
    borderRadius: '12px',
    '& fieldset': { borderColor: applyColors.border },
    '&:hover fieldset': { borderColor: applyColors.accentSoft },
    '&.Mui-focused fieldset': { borderColor: applyColors.primary },
  },
  '& .MuiInputLabel-root': { color: applyColors.textMuted },
  '& .MuiFormHelperText-root': { marginLeft: 0 },
};

export const primaryButtonSx: SxProps<Theme> = {
  backgroundColor: applyColors.primary,
  color: '#FFFFFF',
  fontWeight: 700,
  fontSize: 15,
  textTransform: 'none',
  borderRadius: '12px',
  py: 1.4,
  px: 3,
  boxShadow: 'none',
  '&:hover': { backgroundColor: applyColors.primaryHover, boxShadow: 'none' },
  '&.Mui-disabled': { backgroundColor: '#354EEF66', color: '#FFFFFF99' },
};

export const ghostButtonSx: SxProps<Theme> = {
  color: applyColors.accent,
  fontWeight: 600,
  fontSize: 14,
  textTransform: 'none',
  borderRadius: '12px',
  py: 1.2,
  px: 2.5,
  border: `1px solid ${applyColors.border}`,
  '&:hover': { backgroundColor: 'rgba(255,255,255,0.05)', borderColor: applyColors.accentSoft },
};

export const chipSx = (selected: boolean): SxProps<Theme> => ({
  height: 38,
  px: 0.5,
  fontSize: 13,
  fontWeight: 600,
  cursor: 'pointer',
  borderRadius: '10px',
  color: selected ? '#FFFFFF' : applyColors.textBody,
  backgroundColor: selected ? applyColors.primary : '#99A8FF14',
  border: `1px solid ${selected ? applyColors.primary : applyColors.border}`,
  transition: 'all .15s ease',
  '&:hover': { backgroundColor: selected ? applyColors.primary : '#99A8FF2E' },
  '& .MuiChip-icon': { color: 'inherit' },
});
